const Routes = Object.freeze({
  DASHBOARD: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CONFIRM_EMAIL: '/confirm-email',
  PAYMENT_SELECT: '/payment-select',
  SETTINGS__CONSENTS: '/settings/consents',
  SETTINGS__PROJECTS: '/settings/projects',
  SETTINGS__SUBSCRIPTION: '/settings/subscription',
} as const);

export default Routes;

export type AvailableRoutes = (typeof Routes)[keyof typeof Routes];
